import {
	connect
} from 'react-redux'
import React from 'react';
import { Well } from 'react-bootstrap';
import SearchEpcCheckComponent from '../components/SearchEpcCheckComponent.jsx';
import {
	findSearchEpcCheck,
	cleanSearchEpcAlert
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	alertStyle: state.getIn(['searchReducer', 'alertStyle']),
	alertMessage: state.getIn(['searchReducer', 'alertMessage']),
	searchCheckResult: replaceSearchCheckResult(state.getIn(['searchReducer', 'searchCheckResult'])),
})

const mapDispatchToProps = (dispatch) => ({
	searchEpc: (searchEpcInput) => {
		dispatch(findSearchEpcCheck({ searchEpcInput: searchEpcInput }));
	},
	cleanAlert: () => {
		dispatch(cleanSearchEpcAlert());
	}
})

function replaceSearchCheckResult(searchCheckResult) {
	if (searchCheckResult) {
		searchCheckResult = searchCheckResult.replace(/\r\n/g, '<br />');
		searchCheckResult = searchCheckResult.replace(/\[/g, '<span style="color:red">');
		searchCheckResult = searchCheckResult.replace(/\]/g, '</span>');

		return (<Well dangerouslySetInnerHTML={{ __html: searchCheckResult }} />);
	} else {
		return null;
	}
}

const SearchEpcCheckContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchEpcCheckComponent)

export default SearchEpcCheckContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchEpcCheckContainer.jsx